import React from 'react';
import { MenuContentTemplate } from '../../components';
import { DemoPortalRoutes, menus } from './demoRouter';

export const DemoPortal = ({ navigation }: any) => {
  return (
    <MenuContentTemplate navigation={navigation} menus={menus} menuTitle="Demo Menu" requiredLogin={false}>
      <DemoPortalRoutes />
    </MenuContentTemplate>
  );
};
